import { keyframes } from '@emotion/react';

export const fadeInOpacity = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.2);
  }
`;
